import React, { useMemo } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { getDevDocsConnectionIcons } from '../utils/getDevDocsConnectionIcons.ts';

import type { ConnectionSectionsData } from './sections/useConnectionSectionsData.ts';
import { TeamworkGraphPreviewPanelOpenGraphButton } from './TeamworkGraphPreviewPanelOpenGraphButton.tsx';

const styles = cssMap({
	footer: {
		flexShrink: 0,
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		paddingBlock: token('space.200'),
		paddingInline: token('space.300'),
		borderTopStyle: 'solid',
		borderTopWidth: token('border.width'),
		borderTopColor: token('color.border'),
		backgroundColor: token('elevation.surface'),
	},
});

export function TeamworkGraphPreviewPanelFooter({
	connections,
	onOpenGraph,
	testId,
}: {
	/** Feeds the button's icon stack, so it summarises the same connections as the byline. */
	connections: ConnectionSectionsData;
	onOpenGraph: () => void;
	testId?: string;
}): React.JSX.Element {
	const devDocsConnection = connections.syncedFrom.connection;
	const devDocsIcons = useMemo(
		() => getDevDocsConnectionIcons(devDocsConnection),
		[devDocsConnection],
	);

	return (
		<Box as="footer" testId={testId} xcss={styles.footer}>
			<TeamworkGraphPreviewPanelOpenGraphButton
				links={connections.linksTo.links}
				incomingLinks={connections.appearsIn.links}
				additionalIcons={devDocsIcons}
				onClick={onOpenGraph}
				testId={testId && `${testId}-open-graph`}
			/>
		</Box>
	);
}
